import { Waybill } from 'models/Waybill';

/**
 * Utility for downloading waybills directly from their URL
 */
export const downloadWaybill = async (waybill: Waybill, fileName: string): Promise<void> => {
  try {
    const response = await fetch(waybill.url);

    if (!response.ok) {
      throw new Error(`Download failed: ${response.status} ${response.statusText}`);
    }

    // Check if response is actually a PDF
    const contentType = response.headers.get('content-type');

    if (!contentType || !contentType.includes('application/pdf')) {
      console.warn('Response is not a PDF:', contentType);
    }

    const blob = await response.blob();

    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    link.style.display = 'none';
    link.target = '_blank'; // Try to force download in new tab if needed

    // Add to DOM and trigger download
    document.body.appendChild(link);

    // Small delay to ensure DOM is ready
    await new Promise((resolve) => setTimeout(resolve, 100));

    link.click();

    // Keep link in DOM longer to ensure download starts
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);
  } catch (error) {
    console.warn('Direct download failed due to CORS, opening in new tab:', error);

    // Fallback: Open PDF in new tab for manual download
    const newWindow = window.open(waybill.url, '_blank');

    if (newWindow) {
      // Show user instruction
      alert('PDF opened in new tab. Please right-click and "Save As" to download.');
    } else {
      throw new Error('Failed to open PDF in new tab. Please check your popup blocker.');
    }
  }
};

/**
 * Generate a standardized filename for waybill downloads
 */
export const generateWaybillFileName = (sparingRequestName: string, packageIndex: number, waybillIndex: number, totalWaybills: number, trackingNumber: string): string => {
  return `${sparingRequestName} - Package ${packageIndex + 1} - Waybill ${waybillIndex + 1} of ${totalWaybills} - ${trackingNumber}.pdf`;
};
